import React from "react";

const FooterSpacer = ({ styles }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "calc(var(--db-footer-height) + 150px)",
        ...styles,
      }}
    ></div>
  );
};

export default FooterSpacer;
